// extracted by mini-css-extract-plugin
export default {"mainContainer":"textCommentComponent_mainContainer__Kta4G","buttonsContainer":"textCommentComponent_buttonsContainer__oWptR"};